// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResponseTemplates.module.css */
.ResponseTemplates_container__DLzpw {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

/* Header */
.ResponseTemplates_header__H5eNF {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 16px;
}

.ResponseTemplates_headerContent__\\+9WgH {
  flex: 1 1;
}

.ResponseTemplates_title__eUblL {
  font-size: 28px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px 0;
}

.ResponseTemplates_subtitle__z-D9A {
  font-size: 16px;
  color: #718096;
  margin: 0;
}

.ResponseTemplates_headerActions__sFDpP {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.ResponseTemplates_createButton__HrvHB {
  padding: 10px 20px;
  background-color: #4a6cf7;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.ResponseTemplates_createButton__HrvHB:hover {
  background-color: #3a56d4;
}

.ResponseTemplates_playgroundButton__iD6d6 {
  padding: 10px 20px;
  background-color: #38a169;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.ResponseTemplates_playgroundButton__iD6d6:hover {
  background-color: #2f855a;
}

/* Filter Bar */
.ResponseTemplates_filterBar__zas8B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 12px 16px;
  background-color: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.ResponseTemplates_filterGroup__fEs5n {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ResponseTemplates_filterLabel__e82lR {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-right: 8px;
}

.ResponseTemplates_filterButton__L8CrX {
  padding: 6px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  background-color: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
}

.ResponseTemplates_filterButton__L8CrX:hover {
  background-color: #edf2f7;
  border-color: #cbd5e0;
}

.ResponseTemplates_activeFilter__KWIRU {
  background-color: #4a6cf7;
  color: white;
  border-color: #4a6cf7;
}

.ResponseTemplates_activeFilter__KWIRU:hover {
  background-color: #3a56d4;
  border-color: #3a56d4;
}

.ResponseTemplates_filterInfo__3OEjb {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ResponseTemplates_filterTag__Hx\\+mS {
  padding: 4px 12px;
  background-color: #edf2f7;
  border-radius: 12px;
  font-size: 12px;
  color: #4a5568;
}

/* Loading */
.ResponseTemplates_loadingContainer__PXO-l {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.ResponseTemplates_loadingSpinner__0rhAg {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #4a6cf7;
  border-radius: 50%;
  animation: ResponseTemplates_spin__JUPMy 1s linear infinite;
}

@keyframes ResponseTemplates_spin__JUPMy {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error */
.ResponseTemplates_errorContainer__lAypU {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: #fed7d7;
  border-radius: 8px;
  color: #c53030;
  margin-bottom: 24px;
}

.ResponseTemplates_errorIcon__rTNXQ {
  font-size: 20px;
}

/* Empty State */
.ResponseTemplates_emptyState__GTRMq {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background-color: #f7fafc;
  border-radius: 12px;
  border: 2px dashed #e2e8f0;
}

.ResponseTemplates_emptyIcon__lp7Yw {
  font-size: 48px;
  margin-bottom: 16px;
}

.ResponseTemplates_emptyState__GTRMq h3 {
  font-size: 20px;
  color: #2d3748;
  margin: 0 0 8px 0;
}

.ResponseTemplates_emptyState__GTRMq p {
  color: #718096;
  margin: 0 0 16px 0;
}

/* Template Grid */
.ResponseTemplates_templateGrid__tWPQL {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.ResponseTemplates_templateCard__G2nge {
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.ResponseTemplates_templateCard__G2nge:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #4a6cf7;
}

/* Template Header */
.ResponseTemplates_templateHeader__xRn5\\+ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.ResponseTemplates_templateBadges__cVP0h {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ResponseTemplates_typeBadge__zXntx {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.ResponseTemplates_statusBadge__cZZ3S {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.ResponseTemplates_templateId__vQtCf {
  font-size: 12px;
  color: #a0aec0;
  font-family: monospace;
}

/* Template Body */
.ResponseTemplates_templateBody__qRqn2 {
  flex: 1 1;
  margin-bottom: 12px;
}

.ResponseTemplates_templateInfo__DbBkA {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 16px;
  margin-bottom: 12px;
}

.ResponseTemplates_templateField__t1Hme {
  display: flex;
  gap: 4px;
  font-size: 13px;
}

.ResponseTemplates_fieldLabel__qpMyO {
  color: #a0aec0;
  font-weight: 500;
}

.ResponseTemplates_fieldValue__G779\\+ {
  color: #2d3748;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ResponseTemplates_templatePreview__h77hP {
  background-color: #f7fafc;
  border-radius: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
}

.ResponseTemplates_previewLabel__zquOb {
  font-size: 12px;
  color: #a0aec0;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.ResponseTemplates_previewContent__Qt\\+S1 {
  font-size: 13px;
  color: #4a5568;
  font-family: 'Courier New', monospace;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 80px;
  overflow: hidden;
  line-height: 1.5;
}

/* Template Footer */
.ResponseTemplates_templateFooter__hb60- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 8px;
}

.ResponseTemplates_viewButton__3xFtP {
  padding: 6px 16px;
  background-color: #4a6cf7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.ResponseTemplates_viewButton__3xFtP:hover {
  background-color: #3a56d4;
}

.ResponseTemplates_controlsBadge__seL1f {
  font-size: 12px;
  color: #718096;
}

/* Summary */
.ResponseTemplates_summary__ldZSq {
  display: flex;
  gap: 24px;
  padding: 16px 20px;
  background-color: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.ResponseTemplates_summaryItem__hddVn {
  display: flex;
  gap: 8px;
  align-items: center;
}

.ResponseTemplates_summaryLabel__yTP2b {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
}

.ResponseTemplates_summaryValue__uXuHv {
  font-size: 16px;
  font-weight: 700;
  color: #2d3748;
}

/* Responsive */
@media (max-width: 768px) {
  .ResponseTemplates_container__DLzpw {
    padding: 16px;
  }
  
  .ResponseTemplates_header__H5eNF {
    flex-direction: column;
  }
  
  .ResponseTemplates_headerActions__sFDpP {
    width: 100%;
  }
  
  .ResponseTemplates_headerActions__sFDpP button {
    flex: 1 1;
  }
  
  .ResponseTemplates_templateGrid__tWPQL {
    grid-template-columns: 1fr;
  }
  
  .ResponseTemplates_templateInfo__DbBkA {
    grid-template-columns: 1fr;
  }
  
  .ResponseTemplates_filterBar__zas8B {
    flex-direction: column;
    align-items: stretch;
  }
  
  .ResponseTemplates_filterGroup__fEs5n {
    flex-wrap: wrap;
  }
  
  .ResponseTemplates_summary__ldZSq {
    flex-direction: column;
    gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ResponseTemplates.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,8FAA8F;AAChG;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,2DAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["/* ResponseTemplates.module.css */\n.container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n}\n\n/* Header */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.headerContent {\n  flex: 1;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 8px 0;\n}\n\n.subtitle {\n  font-size: 16px;\n  color: #718096;\n  margin: 0;\n}\n\n.headerActions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.createButton {\n  padding: 10px 20px;\n  background-color: #4a6cf7;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s;\n}\n\n.createButton:hover {\n  background-color: #3a56d4;\n}\n\n.playgroundButton {\n  padding: 10px 20px;\n  background-color: #38a169;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s;\n}\n\n.playgroundButton:hover {\n  background-color: #2f855a;\n}\n\n/* Filter Bar */\n.filterBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 12px 16px;\n  background-color: #f7fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.filterGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filterLabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568;\n  margin-right: 8px;\n}\n\n.filterButton {\n  padding: 6px 14px;\n  border: 2px solid #e2e8f0;\n  border-radius: 20px;\n  background-color: white;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #4a5568;\n  transition: all 0.2s;\n}\n\n.filterButton:hover {\n  background-color: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.activeFilter {\n  background-color: #4a6cf7;\n  color: white;\n  border-color: #4a6cf7;\n}\n\n.activeFilter:hover {\n  background-color: #3a56d4;\n  border-color: #3a56d4;\n}\n\n.filterInfo {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filterTag {\n  padding: 4px 12px;\n  background-color: #edf2f7;\n  border-radius: 12px;\n  font-size: 12px;\n  color: #4a5568;\n}\n\n/* Loading */\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.loadingSpinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #4a6cf7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error */\n.errorContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background-color: #fed7d7;\n  border-radius: 8px;\n  color: #c53030;\n  margin-bottom: 24px;\n}\n\n.errorIcon {\n  font-size: 20px;\n}\n\n/* Empty State */\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background-color: #f7fafc;\n  border-radius: 12px;\n  border: 2px dashed #e2e8f0;\n}\n\n.emptyIcon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.emptyState h3 {\n  font-size: 20px;\n  color: #2d3748;\n  margin: 0 0 8px 0;\n}\n\n.emptyState p {\n  color: #718096;\n  margin: 0 0 16px 0;\n}\n\n/* Template Grid */\n.templateGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.templateCard {\n  background-color: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.2s;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.templateCard:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: #4a6cf7;\n}\n\n/* Template Header */\n.templateHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.templateBadges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.typeBadge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.statusBadge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.templateId {\n  font-size: 12px;\n  color: #a0aec0;\n  font-family: monospace;\n}\n\n/* Template Body */\n.templateBody {\n  flex: 1;\n  margin-bottom: 12px;\n}\n\n.templateInfo {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 16px;\n  margin-bottom: 12px;\n}\n\n.templateField {\n  display: flex;\n  gap: 4px;\n  font-size: 13px;\n}\n\n.fieldLabel {\n  color: #a0aec0;\n  font-weight: 500;\n}\n\n.fieldValue {\n  color: #2d3748;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.templatePreview {\n  background-color: #f7fafc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.previewLabel {\n  font-size: 12px;\n  color: #a0aec0;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.previewContent {\n  font-size: 13px;\n  color: #4a5568;\n  font-family: 'Courier New', monospace;\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 80px;\n  overflow: hidden;\n  line-height: 1.5;\n}\n\n/* Template Footer */\n.templateFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.viewButton {\n  padding: 6px 16px;\n  background-color: #4a6cf7;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.viewButton:hover {\n  background-color: #3a56d4;\n}\n\n.controlsBadge {\n  font-size: 12px;\n  color: #718096;\n}\n\n/* Summary */\n.summary {\n  display: flex;\n  gap: 24px;\n  padding: 16px 20px;\n  background-color: #f7fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.summaryItem {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.summaryLabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.summaryValue {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2d3748;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n  \n  .header {\n    flex-direction: column;\n  }\n  \n  .headerActions {\n    width: 100%;\n  }\n  \n  .headerActions button {\n    flex: 1;\n  }\n  \n  .templateGrid {\n    grid-template-columns: 1fr;\n  }\n  \n  .templateInfo {\n    grid-template-columns: 1fr;\n  }\n  \n  .filterBar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .filterGroup {\n    flex-wrap: wrap;\n  }\n  \n  .summary {\n    flex-direction: column;\n    gap: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ResponseTemplates_container__DLzpw`,
	"header": `ResponseTemplates_header__H5eNF`,
	"headerContent": `ResponseTemplates_headerContent__+9WgH`,
	"title": `ResponseTemplates_title__eUblL`,
	"subtitle": `ResponseTemplates_subtitle__z-D9A`,
	"headerActions": `ResponseTemplates_headerActions__sFDpP`,
	"createButton": `ResponseTemplates_createButton__HrvHB`,
	"playgroundButton": `ResponseTemplates_playgroundButton__iD6d6`,
	"filterBar": `ResponseTemplates_filterBar__zas8B`,
	"filterGroup": `ResponseTemplates_filterGroup__fEs5n`,
	"filterLabel": `ResponseTemplates_filterLabel__e82lR`,
	"filterButton": `ResponseTemplates_filterButton__L8CrX`,
	"activeFilter": `ResponseTemplates_activeFilter__KWIRU`,
	"filterInfo": `ResponseTemplates_filterInfo__3OEjb`,
	"filterTag": `ResponseTemplates_filterTag__Hx+mS`,
	"loadingContainer": `ResponseTemplates_loadingContainer__PXO-l`,
	"loadingSpinner": `ResponseTemplates_loadingSpinner__0rhAg`,
	"spin": `ResponseTemplates_spin__JUPMy`,
	"errorContainer": `ResponseTemplates_errorContainer__lAypU`,
	"errorIcon": `ResponseTemplates_errorIcon__rTNXQ`,
	"emptyState": `ResponseTemplates_emptyState__GTRMq`,
	"emptyIcon": `ResponseTemplates_emptyIcon__lp7Yw`,
	"templateGrid": `ResponseTemplates_templateGrid__tWPQL`,
	"templateCard": `ResponseTemplates_templateCard__G2nge`,
	"templateHeader": `ResponseTemplates_templateHeader__xRn5+`,
	"templateBadges": `ResponseTemplates_templateBadges__cVP0h`,
	"typeBadge": `ResponseTemplates_typeBadge__zXntx`,
	"statusBadge": `ResponseTemplates_statusBadge__cZZ3S`,
	"templateId": `ResponseTemplates_templateId__vQtCf`,
	"templateBody": `ResponseTemplates_templateBody__qRqn2`,
	"templateInfo": `ResponseTemplates_templateInfo__DbBkA`,
	"templateField": `ResponseTemplates_templateField__t1Hme`,
	"fieldLabel": `ResponseTemplates_fieldLabel__qpMyO`,
	"fieldValue": `ResponseTemplates_fieldValue__G779+`,
	"templatePreview": `ResponseTemplates_templatePreview__h77hP`,
	"previewLabel": `ResponseTemplates_previewLabel__zquOb`,
	"previewContent": `ResponseTemplates_previewContent__Qt+S1`,
	"templateFooter": `ResponseTemplates_templateFooter__hb60-`,
	"viewButton": `ResponseTemplates_viewButton__3xFtP`,
	"controlsBadge": `ResponseTemplates_controlsBadge__seL1f`,
	"summary": `ResponseTemplates_summary__ldZSq`,
	"summaryItem": `ResponseTemplates_summaryItem__hddVn`,
	"summaryLabel": `ResponseTemplates_summaryLabel__yTP2b`,
	"summaryValue": `ResponseTemplates_summaryValue__uXuHv`
};
export default ___CSS_LOADER_EXPORT___;
